// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCFnkZQs_4jpRNFhKXftW23a7YJLbuobKE",
  authDomain: "quizsapabap2.firebaseapp.com",
  projectId: "quizsapabap2",
  storageBucket: "quizsapabap2.firebasestorage.app",
  messagingSenderId: "961597740244",
  appId: "1:961597740244:web:4fa05f5e8b726d0f96d741"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { db, auth };